<template lang="pug">
  .followAccordionWidth.loadingItems(ref="element", @click="$emit('click')")
    slot {{title}}
</template>
<script>
import $ from 'jquery'
export default {
  props: {
    title: {
      required: false,
      default: 'Default Loading Header'
    },
    thresold: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      isLoadingHeader: true,
      triggered: false
    }
  },
  methods: {
    isAlmostVisible (container) {
      if (!this.$refs.element) {
        return false
      }
      let pHeight = container.height()
      let scrollTop = container[0].scrollTop
      let top = $(this.$refs.element).position().top
      let thisHeight = $(this.$refs.element).height()
      // console.log({
      //   top,
      //   thisHeight,
      //   scrollTop,
      //   thresold: this.thresold,
      //   pHeight
      // })
      return top + thisHeight > scrollTop + this.thresold && top + thisHeight < pHeight + scrollTop
    },
    load () {
      this.$emit('fire')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Accordion-LoadingHeader.vue?708b8ed0